module.exports = __webpack_public_path__ + "img/mobilepropertyoffice1.3d6816fa.png";